import { styled } from "@mui/material";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import { default as DrawerMaterial } from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Drawer = ({ open, setOpen, menuArray }: any) => {
  return (
    <DrawerMaterial anchor='left' open={open} onClose={() => setOpen(false)}>
      <Box
        sx={{ width: 250, backgroundColor: "primary.main", color: "primary.light", height: "inherit" }}
        role='presentation'
        onKeyDown={() => setOpen(false)}
      >
        <List>
          <ListItem disablePadding>
            <ListItemButton>
              <Link to='/'>
                <ListItemText primary='Inicio' />
              </Link>
            </ListItemButton>
          </ListItem>
        </List>
        <Divider sx={{ borderColor: "#fff" }} />
        {menuArray?.map(({ id, title, options }: any, index: number) => (
          <AccordionStyled key={`${index}-${id}`}>
            <AccordionSummary expandIcon={<ExpandMoreIcon color='secondary' />} aria-controls='panel1a-content' id={id}>
              <Typography>{title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {options?.map(({ route, title }: any, index: number) => (
                <ListItem disablePadding key={`${index}-${id}`}>
                  <Link to={route}>
                    <ListItemButton onClick={() => setOpen(false)}>
                      <ListItemText primary={title} />
                    </ListItemButton>
                  </Link>
                </ListItem>
              ))}
            </AccordionDetails>
          </AccordionStyled>
        ))}
      </Box>
    </DrawerMaterial>
  );
};

export default Drawer;

const AccordionStyled = styled(Accordion)`
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2);
  background-color: ${({ theme }) => theme.palette.primary.main};
  color: inherit;
  ::before {
    background-color: transparent;
  }
`;
